import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Modal from 'components/Shared/Modal'

interface RemovedFromRoomModalProps {
  onClose: () => void
}

const RemovedFromRoomModal: React.FC<RemovedFromRoomModalProps> = ({
  onClose,
}) => {
  const location = useLocation()
  const initialPathname = useRef(location.pathname)

  const handleReload = () => {
    window.location.reload()
  }

  useEffect(() => {
    // Only close if the pathname has changed from the initial one
    if (location.pathname !== initialPathname.current) {
      onClose()
    }
  }, [location.pathname, onClose])

  return (
    <div>
      <Modal.Header>
        <h1>Session Stopped</h1>
      </Modal.Header>
      <Modal.Content>
        <p>
          Your editing session from this app has been stopped by an
          administrator. Please switch to a different app using the App Switcher
          or reload the page.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Modal.Button type="button" onClick={handleReload}>
          Reload
        </Modal.Button>
      </Modal.Actions>
    </div>
  )
}

export default RemovedFromRoomModal
